import { length } from 'stringz';

export const CharacterCounter: React.FC<{
  text: string;
  max: number;
}> = ({ text, max }) => {
  const diff = max - length(text);
  const formatted = diff.toLocaleString('en-GB');

  if (diff < 0) {
    return (
      <span className='character-counter character-counter--over'>{formatted}</span>
    );
  }

  return <span className='character-counter'>{formatted}</span>;
};
